export const dummyNodeData = [
    {
        "id": "start-node",
        "next": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7",
        "type": "startNode",
        "position": {
            "x": -210,
            "y": 174
        },
        "data": {
            "name": "Start"
        },
        "width": 54,
        "height": 40,
        "selected": true,
        "positionAbsolute": {
            "x": -210,
            "y": 174
        },
        "dragging": false
    },
    {
        "id": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7",
        "type": "botMsgNode",
        "position": {
            "x": -76,
            "y": 144
        },
        "data": {},
        "prev": "start-node",
        "message": {
            "en": "Hi. - Good {get_time_of_day}.;This is {agent_name}.;Am I talking to {user_name}?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "f1660ae1-eb86-4dc8-82ef-009d21f886c6",
                "next": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "d360b7c8-ec5f-4609-98f5-216c3a0e2eef",
                "next": "55cfec4c-1853-419f-ba27-cbc90b3568f1",
                "input": "no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": -76,
            "y": 144
        },
        "dragging": false,
        "default_user_input": "f1660ae1-eb86-4dc8-82ef-009d21f886c6"
    },
    {
        "id": "f1660ae1-eb86-4dc8-82ef-009d21f886c6",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7"
        },
        "parentNode": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "d360b7c8-ec5f-4609-98f5-216c3a0e2eef",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7"
        },
        "parentNode": "7dacde48-4fe7-45da-8d77-7e75d23f6cc7",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7",
        "type": "botMsgNode",
        "position": {
            "x": 290,
            "y": 12
        },
        "data": {},
        "prev": "f1660ae1-eb86-4dc8-82ef-009d21f886c6",
        "message": {
            "en": "Great, Hi {user_name}, This call is arranged for you, because you have shown interest in the, {category}, exam preparation.;Before sharing more information, I would like to know just one or two details about you. Is that ok?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "0ce605e9-71ce-45e1-9be0-b16c15611628",
                "next": "61267fff-3dc7-4802-9b3d-4d50d86d3d93",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "13ad1cbb-4701-46db-95aa-a5c9fdefa4b0",
                "next": "14ad840a-5ada-491d-a3cd-f59e2d1e61d9",
                "input": "no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 290,
            "y": 12
        },
        "dragging": false,
        "default_user_input": "0ce605e9-71ce-45e1-9be0-b16c15611628"
    },
    {
        "id": "0ce605e9-71ce-45e1-9be0-b16c15611628",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7"
        },
        "parentNode": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "13ad1cbb-4701-46db-95aa-a5c9fdefa4b0",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7"
        },
        "parentNode": "5bff612f-cbf6-45e4-8bbb-4ff9251e78b7",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "61267fff-3dc7-4802-9b3d-4d50d86d3d93",
        "type": "botMsgNode",
        "position": {
            "x": 636,
            "y": 10
        },
        "data": {},
        "prev": "0ce605e9-71ce-45e1-9be0-b16c15611628",
        "message": {
            "en": "So, Are you preparing for the {category} exam?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "2e8f3e0b-2c87-42b3-b084-042f30132ce6",
                "next": "38cbd8b3-c5d6-49c0-9af9-05b7f33ecd9e",
                "input": "yes;okay;sure;makes sense;not Yet;will start from next;not yet started but planned",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "ba67edd7-d2af-41c7-8e96-89c4a8f1f357",
                "next": "2494758a-586b-4f67-9e36-fffe046fca4d",
                "input": "no;you have the wrong person",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 636,
            "y": 10
        },
        "dragging": false,
        "default_user_input": "2e8f3e0b-2c87-42b3-b084-042f30132ce6"
    },
    {
        "id": "2e8f3e0b-2c87-42b3-b084-042f30132ce6",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "61267fff-3dc7-4802-9b3d-4d50d86d3d93"
        },
        "parentNode": "61267fff-3dc7-4802-9b3d-4d50d86d3d93",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "ba67edd7-d2af-41c7-8e96-89c4a8f1f357",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "61267fff-3dc7-4802-9b3d-4d50d86d3d93"
        },
        "parentNode": "61267fff-3dc7-4802-9b3d-4d50d86d3d93",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "38cbd8b3-c5d6-49c0-9af9-05b7f33ecd9e",
        "type": "botMsgNode",
        "position": {
            "x": 980,
            "y": 4
        },
        "data": {},
        "prev": "818408ae-51f7-4d81-8119-2d239ce8f339",
        "message": {
            "en": "Got it. - Are you interested to know about India’s Top rated educators & their best learning techniques, which will enhance your learning experience & will make your {category} exam smoother?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "a5874b53-79a6-4722-9052-b1a5f13267cc",
                "next": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e",
                "input": "yes;okay;sure;makes sense;no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 980,
            "y": 4
        },
        "dragging": false,
        "default_user_input": "a5874b53-79a6-4722-9052-b1a5f13267cc"
    },
    {
        "id": "a5874b53-79a6-4722-9052-b1a5f13267cc",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "38cbd8b3-c5d6-49c0-9af9-05b7f33ecd9e"
        },
        "parentNode": "38cbd8b3-c5d6-49c0-9af9-05b7f33ecd9e",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e",
        "type": "botMsgNode",
        "position": {
            "x": 1314,
            "y": -2
        },
        "data": {},
        "prev": "a5874b53-79a6-4722-9052-b1a5f13267cc",
        "message": {
            "en": "Ok, Thank you for sharing the details.;Can we arrange a detailed call back from our end?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "ac01a5f9-0e08-423f-abd8-3c2289bfaa0f",
                "next": "5e8dffb4-f94d-44f2-8b1b-71bfac08b0aa",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "521e5bd5-56e7-4e9a-af28-5b010e76f8d0",
                "next": "5ff1baa9-19ff-4544-a4d0-cdb489cef9b3",
                "input": "no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 1314,
            "y": -2
        },
        "dragging": false,
        "default_user_input": "521e5bd5-56e7-4e9a-af28-5b010e76f8d0"
    },
    {
        "id": "ac01a5f9-0e08-423f-abd8-3c2289bfaa0f",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e"
        },
        "parentNode": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "521e5bd5-56e7-4e9a-af28-5b010e76f8d0",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e"
        },
        "parentNode": "d8b0afe1-ce81-4a45-bb5b-509a14381a2e",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "5e8dffb4-f94d-44f2-8b1b-71bfac08b0aa",
        "type": "botMsgNode",
        "position": {
            "x": 1648.8,
            "y": 8
        },
        "data": {},
        "prev": "ac01a5f9-0e08-423f-abd8-3c2289bfaa0f",
        "message": {
            "en": "What day and time would work best for you?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "84809228-af92-47b3-ab7f-a084583c914f",
                "next": "5ff1baa9-19ff-4544-a4d0-cdb489cef9b3",
                "input": "yes;okay;sure;makes sense;no;any time;any date",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 1648.8,
            "y": 8
        },
        "dragging": false,
        "default_user_input": "84809228-af92-47b3-ab7f-a084583c914f"
    },
    {
        "id": "84809228-af92-47b3-ab7f-a084583c914f",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "5e8dffb4-f94d-44f2-8b1b-71bfac08b0aa"
        },
        "parentNode": "5e8dffb4-f94d-44f2-8b1b-71bfac08b0aa",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "5ff1baa9-19ff-4544-a4d0-cdb489cef9b3",
        "type": "botMsgNode",
        "position": {
            "x": 2068,
            "y": 278
        },
        "data": {
            "isEnd": true
        },
        "prev": "521e5bd5-56e7-4e9a-af28-5b010e76f8d0",
        "message": {
            "en": "Thank you for sharing your preference.;It was a pleasure talking to you. You were talking to {agent_name}.;Have a wonderful day ahead!",
            "hi": ""
        },
        "user_inputs": [],
        "interruptions": [
            "STOP"
        ],
        "specific_interruptions": [],
        "width": 230,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 2068,
            "y": 278
        },
        "dragging": false
    },
    {
        "id": "55cfec4c-1853-419f-ba27-cbc90b3568f1",
        "type": "botMsgNode",
        "position": {
            "x": 280.7999999999997,
            "y": 426
        },
        "data": {},
        "prev": "d360b7c8-ec5f-4609-98f5-216c3a0e2eef",
        "message": {
            "en": "Got it, This call is arranged, because you have shown interest in the, {category}, exam preparation.;Are you preparing for the {category} exam?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "aed16c1a-e837-46f4-a400-a80da0dba7b0",
                "next": "fe611dcd-5ee4-4980-b27f-422d324627ae",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "335ae9e3-41fc-4275-8697-a8e1d0ea7b9a",
                "next": "2494758a-586b-4f67-9e36-fffe046fca4d",
                "input": "no;no, busy right now;can we talk later",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 280.7999999999997,
            "y": 426
        },
        "dragging": false,
        "default_user_input": "aed16c1a-e837-46f4-a400-a80da0dba7b0"
    },
    {
        "id": "aed16c1a-e837-46f4-a400-a80da0dba7b0",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "55cfec4c-1853-419f-ba27-cbc90b3568f1"
        },
        "parentNode": "55cfec4c-1853-419f-ba27-cbc90b3568f1",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "335ae9e3-41fc-4275-8697-a8e1d0ea7b9a",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "55cfec4c-1853-419f-ba27-cbc90b3568f1"
        },
        "parentNode": "55cfec4c-1853-419f-ba27-cbc90b3568f1",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "fe611dcd-5ee4-4980-b27f-422d324627ae",
        "type": "botMsgNode",
        "position": {
            "x": 622,
            "y": 336
        },
        "data": {},
        "prev": "aed16c1a-e837-46f4-a400-a80da0dba7b0",
        "message": {
            "en": "Got it, May I know who am I talking to?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "818408ae-51f7-4d81-8119-2d239ce8f339",
                "next": "38cbd8b3-c5d6-49c0-9af9-05b7f33ecd9e",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "1403dfd6-1528-4ea4-a3ef-a17c2bb06f44",
                "next": "2494758a-586b-4f67-9e36-fffe046fca4d",
                "input": "no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 622,
            "y": 336
        },
        "dragging": false,
        "default_user_input": "818408ae-51f7-4d81-8119-2d239ce8f339"
    },
    {
        "id": "818408ae-51f7-4d81-8119-2d239ce8f339",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "fe611dcd-5ee4-4980-b27f-422d324627ae"
        },
        "parentNode": "fe611dcd-5ee4-4980-b27f-422d324627ae",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "1403dfd6-1528-4ea4-a3ef-a17c2bb06f44",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "fe611dcd-5ee4-4980-b27f-422d324627ae"
        },
        "parentNode": "fe611dcd-5ee4-4980-b27f-422d324627ae",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "2494758a-586b-4f67-9e36-fffe046fca4d",
        "type": "botMsgNode",
        "position": {
            "x": 2072,
            "y": 562
        },
        "data": {
            "isEnd": true
        },
        "prev": "f51b47a1-ba1f-4d66-a07e-5df6ae0979b7",
        "message": {
            "en": "Okay thanks, I will call you back later.",
            "hi": ""
        },
        "user_inputs": [],
        "interruptions": [
            "STOP"
        ],
        "specific_interruptions": [],
        "width": 230,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 2072,
            "y": 562
        },
        "dragging": false
    },
    {
        "id": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2",
        "type": "botMsgNode",
        "position": {
            "x": 1124,
            "y": 760
        },
        "data": {},
        "prev": "1cdee10a-319d-434e-9d54-f10d82ce6e43",
        "message": {
            "en": "This is {agent_name}.;I am calling from an EdTech company.;Can I continue?",
            "hi": ""
        },
        "user_inputs": [
            {
                "id": "8f7b7590-c63d-462b-b99d-b44ffc5c6592",
                "next": "destination",
                "input": "yes;okay;sure;makes sense",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            },
            {
                "id": "f51b47a1-ba1f-4d66-a07e-5df6ae0979b7",
                "next": "2494758a-586b-4f67-9e36-fffe046fca4d",
                "input": "no",
                "message": {
                    "en": [],
                    "hi": []
                },
                "action": ""
            }
        ],
        "interruptions": [
            "all"
        ],
        "specific_interruptions": [],
        "width": 290,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 1124,
            "y": 760
        },
        "dragging": false,
        "default_user_input": "8f7b7590-c63d-462b-b99d-b44ffc5c6592"
    },
    {
        "id": "8f7b7590-c63d-462b-b99d-b44ffc5c6592",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 100
        },
        "data": {
            "parentNodeId": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2"
        },
        "parentNode": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "f51b47a1-ba1f-4d66-a07e-5df6ae0979b7",
        "type": "userMsgNode",
        "position": {
            "x": 0,
            "y": 150
        },
        "data": {
            "parentNodeId": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2"
        },
        "parentNode": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2",
        "draggable": false,
        "width": 231,
        "height": 60,
        "selected": false
    },
    {
        "id": "14ad840a-5ada-491d-a3cd-f59e2d1e61d9",
        "type": "botMsgNode",
        "position": {
            "x": 698,
            "y": -198
        },
        "data": {
            "isEnd": true
        },
        "prev": "13ad1cbb-4701-46db-95aa-a5c9fdefa4b0",
        "message": {
            "en": "Sure, I will call you back later.",
            "hi": ""
        },
        "user_inputs": [],
        "interruptions": [
            "STOP"
        ],
        "specific_interruptions": [],
        "width": 230,
        "height": 100,
        "selected": false,
        "positionAbsolute": {
            "x": 698,
            "y": -198
        },
        "dragging": false
    },
    {
        "id": "1cdee10a-319d-434e-9d54-f10d82ce6e43",
        "type": "startNode",
        "position": {
            "x": 718.0000000000009,
            "y": 792
        },
        "data": {
            "name": "Intermediate_Start_1"
        },
        "next": "6c2e6794-b532-45f4-b6f0-b2eda1b2c8a2",
        "width": 186,
        "height": 40,
        "selected": false,
        "positionAbsolute": {
            "x": 718.0000000000009,
            "y": 792
        },
        "dragging": false
    },
    {
        "id": "d0859ea1-418e-41d2-9b88-f808f9b348c5",
        "type": "stopNode",
        "position": {
            "x": 1654.000000000001,
            "y": 864
        },
        "data": {
            "name": "Intermediate_Stop_1"
        },
        "prev": "8f7b7590-c63d-462b-b99d-b44ffc5c6592",
        "width": 184,
        "height": 40,
        "selected": false,
        "positionAbsolute": {
            "x": 1654.000000000001,
            "y": 864
        },
        "dragging": false
    }
]

export function arrayToObject(arr) {
    return arr.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
    }, {});
}

export function objectToArray(obj) {
    return Object.values(obj);
}